import { observer } from 'mobx-react-lite'
import { getRequestDraftReturnText } from '@/features/jobs/details/components/JobProgressionCard/request-draft-return-text'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import { DraftRejectedProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/DraftRejectedProgressionActions'

export interface DraftRejectedProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const DraftRejectedProgressionActionsContainer = observer(
  function DraftRejectedProgressionActionsContainer({
    vm,
  }: DraftRejectedProgressionActionsContainerProps) {
    return (
      <DraftRejectedProgressionActions
        isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
        hasDraftReturn={vm.hasDraftReturn}
        isDraftReturnDownloadable={vm.isDraftReturnDownloadable}
        requestDraftApprovalLabel={getRequestDraftReturnText(
          vm.hasDraftReturn,
          vm.isDraftReturnDownloadable,
          vm.currentProgressionFlow,
        )}
        onReportOpenItems={vm.reportOpenItems}
        onRequestDraftApproval={vm.answerDraftInReview}
        extensionActions={
          vm.isAnyExtensionFlowAvailable && (
            <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
          )
        }
      />
    )
  },
)
